module.exports = __webpack_public_path__ + "img/guide_icon_4.ff0a2f0e.svg";